const TransferKiloBytesToGB = (value) => {
    return (value / 1024 / 1024).toFixed(2)
}

const TransferKiloBytesToMB = (value) => {
    return (value / 1024).toFixed(2)
}

export { TransferKiloBytesToGB, TransferKiloBytesToMB}